/*
 * @Description: 项目入口文件
 * @Author: shufei
 * @Date: 2021-11-04 09:50:04
 * @LastEditTime: 2021-11-18 18:27:26
 * @LastEditors: shufei
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueTouch from 'vue-touch'
import store from '@/store'
import '@/assets/icons'
import '@/components/public'
import '@/api'
import '@/filters'
import '@/directives'
import '@/mixins'
import '@/util'
import '@/core/vant'
import 'vant/lib/index.css'
import '@/assets/css/index.scss'
// import 'lib-flexible'
import 'amfe-flexible'
import '@/router/permission' // 路由权限控制
import Vconsole from 'vconsole'
import Cookies from 'js-cookie'

import { Notify, Toast } from 'vant'
// 若地址中包含vconsole=true则开启vconsole
const url = window.location.href
const userid = Cookies.get('userid')
if (url.indexOf('vconsole=true') > -1 || userid === '462169072986161152' || userid === '422322150108753920') {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}
Vue.use(VueTouch, { name: 'v-touch' })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)
    function updateOnlineStatus(event) {
      const condition = navigator.onLine ? 'online' : 'offline'
      if (condition === 'online') {
        Notify({ type: 'success', message: '你的网络已连接' })
      } else {
        Notify({ type: 'danger', message: '你的网络已断开', duration: 6666 })
        // 去除所有toast
        Toast.clear()
      }
    }
  }
}).$mount('#app')
